const angular = require('angular')

module.exports = function() {
  return {
    restrict: 'A',
    scope: {},
    link: function (scope, elem, attr) {
      const $input = angular.element(elem)
      console.log('AUTO FOCUS: ' + JSON.stringify(attr))
      $input.ready(function() {
        elem[0].focus()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/netFolder/autofocusDirective.js